<template>
  <div>
    <div v-if="activationsOCRHistory === 'false'">
      <h3 class="title-content">Históricos</h3>
      <v-card class="form-card">
        <div class="d-block d-md-flex flex-grow-1 buttons">
          <button @click="tabComponent = 'WalletsHistory'"
                  v-if="showWallets === 'true'"
                  :class="{'active':tabComponent === 'WalletsHistory','inactive':tabComponent === 'VehiclesHistory'}"
                  class="btn-confirm">
            <i class="fas fa-wallet mr-2"></i>
            {{ advancedWalletOptions === 'true' && showWallets === 'true' ? 'MINHAS CARTEIRAS' : 'MEUS CRÉDITOS' }}
          </button>
          <button @click="tabComponent = 'VehiclesHistory'"
                  :class="{'active':tabComponent === 'VehiclesHistory','inactive':tabComponent === 'WalletsHistory'}"
                  class="btn-confirm">
            <i class="fas fa-car mr-2"></i>
            MEUS VEÍCULOS
          </button>
        </div>
        <v-form ref="formHistory">
          <component v-bind:is="tabComponent"></component>
        </v-form>
      </v-card>
    </div>
  </div>
</template>
<script>
import VehiclesHistory from '../components/VehiclesHistory';
import WalletsHistory from '../components/WalletsHistory';

export default {
  name: "History",
  components: {VehiclesHistory, WalletsHistory},
  data: function () {
    return {
      tabComponent: 'VehiclesHistory'
    }
  },
  computed: {
    advancedWalletOptions: function () {
      return process.env.VUE_APP_ADVANCED_WALLET_OPTIONS;
    },
    showWallets() {
      return process.env.VUE_APP_SHOW_WALLETS;
    },
    activationsOCRHistory() {
      return process.env.VUE_APP_ACTIVATIONS_OCR_HISTORY;
    }
  }
}
</script>

<style scoped>
.tab-style {
  font-family: Roboto-Black;
}

.buttons button {
  flex: 1;
}

.buttons .btn-confirm.active:hover {
  background: #000 !important;
  color: #ffffff !important;
  cursor: auto;
}

.buttons .btn-confirm.inactive:hover {
  background: #000 !important;
  color: #ffffff !important;
  border: 3px solid #000 !important;
  cursor: pointer;
}

.buttons .btn-confirm.inactive {
  background: #e4e4e4 !important;
  border: 3px solid #e4e4e4 !important;
  color: #595959 !important;
}

@media only screen and (max-width: 500px) {
  .form-card {
    width: 90vw;
  }

  .buttons button {
    width: 100%;
    margin: 5px 0;
  }
}

</style>
